/*
 *
 * ExtendSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from './languageModule'
import { useIntl } from 'react-intl'

const ExtendSessionModal = (props) => {
  const intl = useIntl()

  const primaryActionHandler = () => {
    props.actions.extendSession()
  }

  // const sessionTime = props.sessionType === 'ANON' ? 60 : 5

  return (
    <MerchantModal
      title={intl.formatMessage({ id: 't.app.extendSessionModal.title', defaultMessage: 'Sessione in scadenza' })}
      description={intl.formatMessage({ id: 't.app.extendSessionModal.description', defaultMessage: 'La tua sessione sta per scadere.' })}
      primaryButtonLabel={formattedMessage.primaryButtonLabel}
      primaryAction={primaryActionHandler}
      primaryButtonLoading={props.isLoading}
      onClose={() => props.actions.hidePopup()}
    />
  )
}

ExtendSessionModal.propTypes = {
  actions: PropTypes.object,
  isLoading: PropTypes.bool,
  sessionType: PropTypes.string
}

ExtendSessionModal.defaultProps = {
  actions: {},
  isLoading: false,
  sessionType: 'PORTAL'
}

export default ExtendSessionModal
